import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getConnectedTrucks = (slug) => {
  const url = API_URLS.connectedTruck(slug);
  return axiosClient.get(url);
};

export const getPurchasedTruck = (id) => {
  const url = API_URLS.purchasedCar(id);
  return axiosClient.get(url);
};
